<template>
  <assessment-base
    :state="state"
    :show-tabs="false"
  >
    <div class="container pt-12">
      <template v-if="markingPhases.length">
        <div class="hidden md:flex">
          <div class="flex-1"></div>
          <div class="w-24 text-xs uppercase font-bold flex-no-shrink py-2 text-center">
            Remaining
          </div>
          <div class="w-24 text-xs uppercase font-bold flex-no-shrink py-2 text-center">
            Completed
          </div>
          <div class="w-24 text-xs uppercase font-bold flex-no-shrink py-2 text-center">
            Total
          </div>
        </div>
        <div class="bg-white shadow-lg">
          <a
            v-for="(phase,index) in markingPhases"
            :key="phase.id"
            :href="route('assessments.phases.view', [state.funding_pot.id, phase.id])"
            class="group block md:flex relative border-grey-200 last:border-0 text-inherit no-underline hover:bg-primary-50 hover:border-primary-500"
            :class="{
              'border-b-4 md:border-b': index + 1 !== markingPhases.length
            }"
          >
            <div class="flex-1 px-6 py-4 flex flex-col justify-center">
              <h2 class="text-xl leading-tight truncate">
                {{ index + 1 }}: {{ phase.name }}
              </h2>
              <p
                class="text-xs mb-1 text-grey-500"
              >{{ phase.name }} is currently <span :class="phase.locked ? 'text-negative-500' : 'text-positive-600'">{{ phase.locked ? 'locked' : 'unlocked' }}</span></p>
            </div>
            <div class="flex border-t-2 md:border-t-0 group-hover:border-primary-500">
              <div class="w-1/3 md:w-24 text-2xl flex flex-col items-center justify-center flex-no-shrink md:border-l py-4 group-hover:border-primary-500">
                <span class="uppercase font-bold text-xs block md:hidden">Remaining</span>
                {{ phase.applications_total_count - phase.applications_completed_count }}
              </div>
              <div class="w-1/3 md:w-24 text-2xl flex flex-col items-center justify-center flex-no-shrink border-l py-4 group-hover:border-primary-500">
                <span class="uppercase font-bold text-xs block md:hidden">Completed</span>
                {{ phase.applications_completed_count }}
              </div>
              <div class="w-1/3 md:w-24 font-bold text-2xl flex flex-col items-center justify-center flex-no-shrink border-l py-4 group-hover:border-primary-500">
                <span class="uppercase font-bold text-xs block md:hidden">Total</span>
                <span class="text-primary-600">{{ phase.applications_total_count }}</span>
              </div>
            </div>
          </a>
        </div>
      </template>
      <template v-else>
        <div
          class="border-2 border-dashed border-grey-300 p-12 text-xl text-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 931.6 512.8"
            class="w-1/3 min-w-32 mb-6 mx-auto block"
          ><circle
            cx="347.1"
            cy="326"
            r="26.4"
            fill="#97d700"
          /><path
            fill="#fff"
            d="M344.6 337.1l-7.9-10.2 4.6-3.5 3.7 4.8 12.7-13.4 4.2 4-17.3 18.3zM852.3 84h-393V0h393z"
          /><circle
            cx="510.2"
            cy="42"
            r="21.3"
            fill="#97d700"
          /><path
            fill="#3f3d56"
            d="M559.5 27.8a3.6 3.6 0 000 7h259.7a3.6 3.6 0 000-7zM559.5 49.1a3.6 3.6 0 000 7.1h164.1a3.6 3.6 0 100-7z"
          /><path
            fill="#ccc"
            d="M852.3 84h-393V0h393zm-387-6h381V6h-381z"
          /><path
            fill="#fff"
            d="M852.3 189h-393v-84h393z"
          /><circle
            cx="510.2"
            cy="147"
            r="21.3"
            fill="#e6e6e6"
          /><path
            fill="#e6e6e6"
            d="M559.5 132.8a3.6 3.6 0 000 7h259.7a3.6 3.6 0 000-7zM559.5 154.1a3.6 3.6 0 000 7.1h164.1a3.6 3.6 0 100-7z"
          /><path
            fill="#e6e6e6"
            d="M852.3 189h-393v-84h393zm-387-6h381v-72h-381z"
          /><path
            fill="#fff"
            d="M852.3 294h-393v-84h393z"
          /><circle
            cx="510.2"
            cy="252"
            r="21.3"
            fill="#e6e6e6"
          /><path
            fill="#e6e6e6"
            d="M559.5 237.8a3.6 3.6 0 000 7h259.7a3.6 3.6 0 000-7zM559.5 259.1a3.6 3.6 0 000 7.1h164.1a3.6 3.6 0 100-7z"
          /><path
            fill="#e6e6e6"
            d="M852.3 294h-393v-84h393zm-387-6h381v-72h-381z"
          /><path
            fill="#ffb8b8"
            d="M200.8 314a10 10 0 013.2-15l-2.1-22.7 13.5-4.7 2.5 32.1a10 10 0 01-17.1 10.2z"
          /><path
            fill="#ccc"
            d="M215.2 183.6s9.3-19.4 17.5-12.6-11.3 64.3-11.3 64.3l-3 55.8-15.6-1.6-4.4-54.3z"
          /><path
            fill="#ffb8b8"
            d="M91.1 471l11.6 9.4 41.7-40.3-17.1-13.8L91.1 471z"
          /><path
            fill="#2f2e41"
            d="M91.2 464.9l22.8 18.5a18.7 18.7 0 012.8 26.3l-.4.5L79 479.9z"
          /><path
            fill="#ffb8b8"
            d="M252.4 497.1h14.9l7.1-57.6h-22v57.6z"
          /><path
            fill="#2f2e41"
            d="M248.5 492.3H278a18.7 18.7 0 0118.7 18.7v.6h-48.2zM278.6 227.1s28 34.1 21.9 68.2-11 59.7-11 59.7l-9.7 76.7s3.6 21-1.2 26.3c0 0 7.3 12.7-6.1 17.6s-20.7-1.7-20.7-1.7-9.8-14.2-3.7-17.8l2.6-150.6L153 433s-1.8 15.5-14.3 15.6l-15 11.1-17-9.7 8.5-11s-4.8-12.1 6.1-14.6l63.4-82.8 15.8-42.6s8.5-33 31.7-46.3v-14.3z"
          /><path
            fill="#ccc"
            d="M230.4 168a23.3 23.3 0 0130.7-4.3l1 .7a89.8 89.8 0 0121 43.3l4.6 24.9-57.3 12.4-13.4-46.3a26.1 26.1 0 0113.4-30.7z"
          /><path
            fill="#ffb8b8"
            d="M324.5 319.2A11.4 11.4 0 01318 303l-16.5-20.2 9.8-13 23 28.8a11.5 11.5 0 01-9.8 20.6z"
          /><path
            fill="#ccc"
            d="M254.8 186.3s-3.6-24.4 8.5-23.1 30.5 68.2 30.5 68.2l32.9 54.8-15.9 8.5-39-48.7z"
          /><path
            fill="#2f2e41"
            d="M277.1 150.7h-58a4.5 4.5 0 01-4.5-4.5v-25a33.5 33.5 0 0167 0v25a4.5 4.5 0 01-4.5 4.5z"
          /><circle
            cx="255"
            cy="125.6"
            r="24.6"
            fill="#ffb8b8"
          /><path
            fill="#2f2e41"
            d="M289.5 123.7h-30.9l-.3-5.1-1.6 5H252l-.7-10-3.1 10H239v-.4c0-14.6 10.3-26.5 23-26.5h4.4c12.8 0 23.1 11.9 23.1 26.5z"
          /><path
            fill="#2f2e41"
            d="M260 155.4a7.4 7.4 0 01-1.2-.1l-36.8-5.7v-38.3a14.8 14.8 0 0114.7-14.8h25.8l-1 1c-14 14.3-3.5 37.3 4 49.7a5 5 0 01-.4 5.9 6.7 6.7 0 01-5.2 2.3z"
          /><circle
            cx="905.1"
            cy="42"
            r="26.4"
            fill="#97d700"
          /><path
            fill="#fff"
            d="M902.6 53.1L894.7 43l4.6-3.6 3.7 4.8 12.7-13.4 4.2 4-17.3 18.3z"
          /><path
            fill="#ccc"
            d="M382 512.8H1a1 1 0 110-2h381a1 1 0 010 2z"
          /></svg>
          <h2 class="mb-3">
            <strong>You are not assigned to any marking phases for Wave {{ state.funding_pot.id }}.</strong>
          </h2>
          <p>If you believe that this is a mistake, please contact <a :href="'mailto:' + $config.emails.technical">{{ $config.emails.technical }}</a>.</p>
        </div>
      </template>
    </div>
  </assessment-base>
</template>

<script>
export default {
  name: "AssessmentsIndex",
  computed: {
    markingPhases() {
      return this.state.marking_phases ?? []
    }
  }
};
</script>
